import React from 'react'
import LicenseBox from '../../../common/components/LicenseBox'
import useHubCheck from '../../../common/hooks/useHubCheck';

export default function CrumplePopLicenseTable({order}) {
    const installed = true;
    if (!order.id){
        return <></>
    }
    const licenseElements = [];
    order.licenses.forEach(l => {
        licenseElements.push((
            <div key={l.id}>
            {licenseElements.length > 0 && <hr />}
            <LicenseBox license={l} hubInstalled={installed} family='MigrateCPop' version='1.1.23' />
            </div>
        ))
    })

    return (
        <div>
            <h5>Your CrumplePop Activation Keys:</h5>
            {licenseElements}
        </div>
    )
}
